export * from './decoration-pixelization.component';
